﻿import { Link } from 'react-router-dom'
import './sections.css'
import PossoBuildLogo from './PossoBuildLogo'
import { LEGAL_FOOTER_LINKS } from '../pages/legalContent'

const APP_URL = (import.meta.env.VITE_SMARTHIRE_APP_URL || 'http://localhost:3000').replace(/\/$/, '')

const CAREERS_LINK = `${APP_URL}/careers`

const SOCIAL_LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/possobuild/', iconClass: 'fa-brands fa-linkedin-in' },
  { label: 'X', href: 'https://x.com/possobuild', iconClass: 'fa-brands fa-x-twitter' },
  { label: 'Instagram', href: 'https://www.instagram.com/possobuild', iconClass: 'fa-brands fa-instagram' },
]

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-col--brand">
            <PossoBuildLogo width={124} height={22} color="#ffffff" className="footer-logo" />
            <p>The AI Workforce Intelligence Platform trusted by enterprise teams at Big 4 firms and Fortune 100 corporations.</p>
            <p className="footer-tagline">Transforming every stage of the employee journey with AI.</p>
          </div>
          <div className="footer-col footer-col--actions">
            <div className="footer-action-row footer-action-row--links">
              <a href={CAREERS_LINK} className="footer-action-link">Careers</a>
              <Link to="/contact" className="footer-action-link">Contact Us</Link>
            </div>
            <div className="footer-action-row footer-action-row--social">
              {SOCIAL_LINKS.map(link => (
                <a
                  key={link.label}
                  href={link.href}
                  className="footer-social-link"
                  target="_blank"
                  rel="noreferrer"
                  aria-label={link.label}
                  title={link.label}
                >
                  <i className={link.iconClass} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} PossoBuild. All rights reserved.</p>
          <div className="footer-bottom-links">
            {LEGAL_FOOTER_LINKS.filter((link) => link.path !== '/contact').map((link) => (
              <Link key={link.path} to={link.path} className="footer-bottom-link">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
